<template>
    <div v-if="activeSite">
        <h3 class="mb-4">Planificación</h3>

        <div style="min-height=500px">
            <calendar-view
                class="theme-default"
                displayPeriodUom="month"
                monthNameFormat="long"
                :displayPeriodCount="1"
                :show-date="showDate"
                :locale="latinAmericanSpanish"
                :events="getActiveSiteScheduleEvents"
                @click-date="onDayClick"
            >
                <calendar-view-header
                    slot="header"
                    slot-scope="t"
                    :header-props="modifyHeaderProps(t.headerProps)"
                    @input="setShowDate"
                />

                <!-- Event Slot recreated to add popovers to them. -->
                <template
                    slot="event"
                    slot-scope="e"
                    :event="e.event"
                    :weekStartDate="e.weekStartDate"
                    :top="e.top"
                >
                    <div
                        :event="e.event"
                        :weekStartDate="e.weekStartDate"
                        :top="e.top"
                        name="event"
                    >
                        <div
                            :key="e.event.id"
                            :draggable="false"
                            :class="e.event.classes"
                            :title="e.event.title"
                            :style="`top:${e.top};${e.event.originalEvent.style}`"
                            v-b-popover.hover="{
                                title: e.event.title,
                                content: e.event.originalEvent.description ? e.event.originalEvent.description : null
                            }"
                            class="cv-event"
                            @click.stop="onEventClick(e.event, $event)"
                            v-html="e.event.title"
                        />
                    </div>
                </template>
            </calendar-view>
        </div>

        <EventCreateUpdateDeleteModal
            v-if="isUserStudenTeacherOrBetter"
        />

    </div>
</template>

<script>
import EventCreateUpdateDeleteModal from './EventCreateUpdateDeleteModal'
import { mapState, mapGetters } from 'vuex'
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import { nowLocalDateObject } from '@/helpers.js'
require('vue-simple-calendar/static/css/default.css')

export default {
    name: 'SiteScheduling',
    components: {
        CalendarView,
        CalendarViewHeader,
        EventCreateUpdateDeleteModal
    },
    data () {
        return {
            showDate: nowLocalDateObject(),
            latinAmericanSpanish: 'es-419',
            updateMode: false
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteScheduleEvents',
            'isUserStudenTeacherOrBetter'
        ])
    },
    methods: {
        setShowDate (d) {
            this.showDate = d
        },
        modifyHeaderProps (headerProps) {
            // Overwrite the string for the currentPeriodLabel
            headerProps.currentPeriodLabel = 'Hoy'
            return headerProps
        },
        onDayClick (dateObj) {
            this.$store.commit('SET_SELECTED_CALENDAR_DATE', this.getISODateFormat(dateObj))
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', null)
            this.$bvModal.show('modal-create-event')
        },
        onEventClick (calendarItem) {
            if (calendarItem.originalEvent.classes === 'regular-event') {
                this.$store.commit('SET_SELECTED_CRUD_OBJECT', calendarItem.originalEvent)
                this.$bvModal.show('modal-create-event')
            }
        },
        getISODateFormat (dateObj) {
            var day = dateObj.getDate().toString()
            var month = (dateObj.getMonth() + 1).toString()
            day = day.length < 2 ? `0${day}` : day
            month = month.length < 2 ? `0${month}` : month
            var dateString = `${dateObj.getFullYear()}-${month}-${day}`

            return dateString
        }
    }
}
</script>

<style>
.cv-week{
    min-height: 100px !important;
}
div.cv-header-nav button.currentPeriod{
    font-weight: bold  !important;
}
div.cv-day, div.cv-event{
    cursor: pointer  !important;
}
/* CSS selector to Capitalize important strings (Days and Month names) */
div.cv-header-nav button.currentPeriod, div.periodLabel, div.cv-header-days{
    text-transform: capitalize  !important;
}
.evaluation-event{
    background-color: #008cba !important;
    color: whitesmoke;
}
.assignment-event{
    background-color: #5cb85c !important;
    color: whitesmoke;
}
.regular-event{
    background-color: #e99002 !important;
    color: whitesmoke;
}
</style>
